import React from "react";

//https://youtube.com/shorts/7WYg39VqF8A?si=6xgf2uvlIGYGooHM

class MovieClip extends React.Component {
   render() {

    return (
      <iframe
      id="video"
      frameBorder="0"
      padding="2px"
      allowFullScreen
      allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      title="Gobot | Hotelier | Hotel Robot"
      width="100%"
      height="100%"
      src="https://www.youtube.com/embed/7WYg39VqF8A?autoplay=1&mute=1&controls=0&enablejsapi=1&origin=localhost:3000&widgetid=3&forigin=localhost:3000/&aoriginsup=1&gporigin=localhost:3000/&vf=6&loop=1&playlist=7WYg39VqF8A"
      ></iframe>
    );
   }
 
   _onReady(event) {
     event.target.pauseVideo();
   }
 }

 export default MovieClip;